import React from 'react';
import { AlertContainer } from './style';
import SVGIcon from '../../assets/images/svg/SVGIcon';

interface AlertProps {
  type: 'success' | 'error' | 'warning';
  message: string;
  onClose?: () => void;
}

const CustomAlert: React.FC<AlertProps> = ({ type, message, onClose }) => {
  return (
    <AlertContainer>
      {type === 'success' && (
        <SVGIcon name='true-icon' width='20' height='20' viewBox='0 0 16 16' stroke='var(--accent-success)' />
      )}
      {type === 'warning' && <SVGIcon name='warning-icon' width='20' height='20' viewBox='0 0 21 20' />}
      {type === 'error' && <SVGIcon name='error-icon' width='20' height='20' viewBox='0 0 21 20' />}
      <span>{message}</span>
    </AlertContainer>
  );
};

export default CustomAlert;
